import BaseDropifyForm from './BaseDropifyForm';

export default class SharedFileForm extends BaseDropifyForm {

    constructor() {
        super('#shared_file_file');
    }
}